import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/landingPage/Price.tsx");
